import React from "react";

import type { ProcessedPickemEntry } from "@/hooks/firestore/betting/useEntries";

import { PickemSummary } from "./PickemSummary";
import { EntryHeader } from "../EntryHeader";
import { PickemSelections } from "./PickemSelections";

import * as styles from "./PickemEntry.module.scss";

type PickemEntryProps = {
  entry: ProcessedPickemEntry;
};

const PickemEntry = ({ entry }: PickemEntryProps) => {
  return (
    <div className={styles.pickemEntryContainer}>
      <EntryHeader entry={entry} />

      <PickemSelections entry={entry} />

      <PickemSummary entry={entry} />
    </div>
  );
};

export { PickemEntry };
